import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nav: [],
    navStatus: false,
    staffInfo: {} // 当前登录用户的信息
  },
  getters: {
    staffInfo(state) {
      return state.staffInfo;
    }
  },
  mutations: {
    pushNav(state, pathObject) {
      state.nav.push(pathObject);
    },
    spliceNav(state, index) {
      state.nav.splice(index, 1);
    },
    changeNavStatus(state, value) {
      state.navStatus = value;
    },
    setStaffInfo(state, staffObj) {
      state.staffInfo = staffObj;
    }
  },
  actions: {
    pushNav(context, pathObject) {
      context.commit('pushNav', pathObject);
    },
    spliceNav(context, index) {
      context.commit('spliceNav', index);
    },
    changeNavStatus(context, value) {
      context.commit('changeNavStatus', value);
    },
    setStaffInfo(content, staffObj) {
      content.commit('setStaffInfo', staffObj);
    }
  }
});
